import { InsulationProductType } from '@innogy/feh/temporary-core-modules';
import { mockInsulationProductsWithCalculations } from '@innogy/feh/models';

export const mockInsulationProductOverviewViewModel = {
  addressData: {
    street: 'goat-street',
    housenumber: 4,
    housenumberaddition: '',
    postalcode: '1234GT',
    city: 'goat-city',
  },
  isVisible: true,
  products: mockInsulationProductsWithCalculations,
  alreadyInsulated: false,
  suitableProductTypes: [
    InsulationProductType.DAKISOLATIE,
    InsulationProductType.SPOUWMUURISOLATIE,
    InsulationProductType.VLOERISOLATIE,
  ],
  selectedProducts: mockInsulationProductsWithCalculations,
  selectedProductsTotalYearlySavings: 538,
};
